// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__FlK89","productName":"Table_productName__2VkbI"};